import request from '@/utils/request'
import { getToken } from '@/utils/auth'

const SERVER_URL = process.env.VUE_APP_SERVER_URL
const SHOW_REGISTER = process.env.VUE_APP_SHOW_REGISTER


export function canRegister() {
    return SHOW_REGISTER == 'true'
}

function getDevice() {
    return navigator.userAgent.toLowerCase();
}

export function getServerUrl() {
    return SERVER_URL
}

export function getNewToken() {
    const data = {}
    return request({
        url: '/login/un/token',
        method: 'get',
        data
    })
}


export function loginByPasswd(user, password, sliderCode = '') {
    const data = {
        user, password,
        sliderCode,
        deviceType: 'pc',
        device: getDevice()
    }
    return request({
        url: '/login/un/password',
        method: 'post',
        data
    })
}


export function loginByCode(phone, vCode, sliderCode, deviceType = 'pc') {
    const data = {
        phone,
        vCode,
        sliderCode,
        deviceType: deviceType,
        device: getDevice()
    }
    return request({
        url: '/login/un/sms',
        method: 'post',
        data
    })
}


export function loginOut() {
    const data = {}
    return request({
        url: '/login/out',
        method: 'post',
        data
    })
}

export function checkToken() {
    return request({
        url: '/login/un/token/check',
        method: 'get'
    })
}


export function slideCheck(action) {
    const data = {
        action: JSON.stringify(action)
    }
    return request({
        url: '/login/un/slide/check        ',
        method: 'post',
        data: data
    })
}

export function sendCode(sliderCode, phone, smsType) {
    const data = {
        sliderCode, phone, smsType
    }
    return request({
        url: '/sms/un/send',
        method: 'post',
        params: data
    })
}

export function checkCode(smsType, vCode, phone, sliderCode) {
    const data = {
        smsType, vCode, phone, sliderCode
    }
    return request({
        url: '/sms/un/check',
        method: 'get',
        params: data
    })
}

/**
 * 添加注册用户
 * @param {*} phone 注册手机号码
 * @param {*} vCode 手机验证码
 * @param {*} sliderCode 滑块校验结果
 * @param {*} fromAppCd 注册APP
 */
export function addRegister(phone, vCode, sliderCode, password, fromAppCd = 'URMP') {
    const data = {
        phone, vCode, password, fromAppCd, sliderCode
    }
    return request({
        url: '/login/un/register',
        method: 'post',
        data
    })
}

/**
 *  更新用户密码
 * @param {*} phone 
 * @param {*} vCode 
 * @param {*} sliderCode 
 * @param {*} password 
 * @param {*} fromAppCd 
 */
export function setPassword(phone, vCode, sliderCode, newPassword, newPassword2) {
    const data = {
        phone, vCode, newPassword, newPassword2, sliderCode
    }
    return request({
        url: '/login/un/forget/update',
        method: 'post',
        data
    })
}

export function getQrCode(param = "") {
    return getServerUrl() + '/login/un/qrcode/get?token=' + getToken() + param
}


export function getDocImage(docCd) {
    return getServerUrl() + '/file/viewImg?token=' + getToken() + "&docCd=" + docCd
}
/**
 * 获取登录用户的信息
 */
export function getLoginUser() {
    const data = {}
    return request({
        url: '/user/info',
        method: 'post',
        data
    })
}

/**
 * 查询用户的所有角色
 */
export function userAllRoles() {
    const data = {}
    return request({
        url: '/user/userAppRole',
        method: 'post',
        data
    })
}


